export const networkFr = {
    api: {
        error: {
            fetchNetworks: 'Erreur lors de la récupération des partenaires',
            fetchPendingInvites: 'Erreur lors de la récupération des invitations en attente',
            fetchReceivedInvites: 'Erreur lors de la récupération des invitations reçues',
            sendNetworkInvite: "Erreur lors de l'envoi de l'invitation",
            fetchInvite: "Erreur lors de la récupération de l'invitation",
            declineNetworkInvite: "Erreur lors du refus de l'invitation",
            validateNetworkInvite: "Erreur lors de la validation de l'invitation",
            deleteNetwork: 'Erreur lors de la suppression du partenaire'
        },
        success: {
            fetchNetworks: 'Récupération des partenaires effectuée avec succès !',
            fetchPendingInvites: 'Récupération des invitations en attente effectuée avec succès !',
            fetchReceivedInvites: 'Récupération des invitations reçues effectuée avec succès !',
            sendNetworkInvite: "Envoi de l'invitation effectuée avec succès !",
            fetchInvite: 'Récupération des invitations effectuée avec succès !',
            declineNetworkInvite: "L'invitation a bien été refusée !",
            validateNetworkInvite: "L'invitation a bien été acceptée !",
            deleteNetwork: 'Suppression du partenaire effectuée avec succès !'
        }
    }
}
